module.exports = __webpack_public_path__ + "img/Mam.fdad8074.svg";